import React from "react";
import { I18n } from "react-redux-i18n";
import { Flex, Text } from "rebass";
import PvBadge from "../PvBadge";
import {
  PERSON_TRANSPORT_PERM_STATES,
} from "./getPersonTransportPermState";

const StatusBadge = ({
  badgeText,
  label,
  badgeColor,
  w = [1, 1, 1 / 4],
  mb = 2,
  pr = 2,
  hideLabel = false,
}) => {
  return (
    <Flex mb={mb} pr={pr} w={w} alignItems="center">
      <PvBadge message={badgeText} title={label} color={badgeColor} />
      {!hideLabel && <Text>{label}</Text>}
    </Flex>
  );
};

const IndependentDrivingStatusBadge = ({
  lessonsCompleted,
  hideLabel,
  ...props
}) => {
  if (lessonsCompleted) {
    return (
      <StatusBadge
        badgeText={I18n.t("applicant.independent_driving_lessons_badge")}
        label={I18n.t("applicant.independent_driving_lessons_completed")}
        hideLabel={hideLabel}
        {...props}
      />
    );
  } else {
    return (
      <StatusBadge
        badgeColor="berryRed"
        badgeText={I18n.t("applicant.independent_driving_lessons_badge")}
        label={I18n.t("applicant.independent_driving_lessons_incomplete")}
        hideLabel={hideLabel}
        {...props}
      />
    );
  }
};

const IndependentHandlingPermStatusBadge = ({
  independentHandlingPerm,
  hideLabel,
}) => {
  if (independentHandlingPerm) {
    return (
      <StatusBadge
        badgeText={I18n.t("applicant.independent_handling_badge")}
        label={I18n.t("applicant.independent_handling_approved")}
        hideLabel={hideLabel}
      />
    );
  } else {
    return (
      <StatusBadge
        badgeColor="grays.0"
        badgeText={I18n.t("applicant.independent_handling_badge")}
        label={I18n.t("applicant.independent_handling_eligible")}
        hideLabel={hideLabel}
      />
    );
  }
};

const PersonTransportPermStatusBadge = ({
  state,
  hideLabel,
}) => {
  
  const badgeText = I18n.t("applicant.person_transport_perm_badge");

  if (state === PERSON_TRANSPORT_PERM_STATES.PERSON_TRANSPORT_PERM_APPROVED) {
    return (
      <StatusBadge
        badgeText={badgeText}
        label={I18n.t("applicant.person_transport_perm_approved")}
        hideLabel={hideLabel}
      />
    );
  } else if (
    state === PERSON_TRANSPORT_PERM_STATES.PERSON_TRANSPORT_PERM_RECOMENDED
  ) {
    return (
      <StatusBadge
        badgeColor="yellow"
        badgeText={badgeText}
        label={I18n.t("applicant.person_transport_perm_waiting_approval")}
        hideLabel={hideLabel}
      />
    );
  } else if (
    state === PERSON_TRANSPORT_PERM_STATES.PERSON_TRANSPORT_PERM_ELIGIBLE
  ) {
    return (
      <StatusBadge
        badgeColor="grays.0"
        badgeText={badgeText}
        label={I18n.t("applicant.person_transport_perm_eligible")}
        hideLabel={hideLabel}
      />
    );
  } else {
    return (
      <StatusBadge
        badgeColor="berryRed"
        badgeText={badgeText}
        label={I18n.t("applicant.person_transport_perm_not_eligible")}
        hideLabel={hideLabel}
      />
    );
  }
};

export {
  StatusBadge,
  IndependentDrivingStatusBadge,
  IndependentHandlingPermStatusBadge,
  PersonTransportPermStatusBadge,
};



// WEBPACK FOOTER //
// ./src/components/applicant/StatusBadges.jsx